module.exports = __webpack_public_path__ + "img/lang-time.f40a5ebf.svg";